import React from 'react';

const URL_PATTERN = /(https?:\/\/[^\s]+)/g;

/**
 * User-entered plain text (tickets, comments): React escapes markup; URLs become links.
 */
export function FormattedPlainText({ text, className = '' }) {
  if (text == null || text === '') {
    return null;
  }

  const parts = String(text).split(URL_PATTERN);

  return (
    <p className={className}>
      {parts.map((part, index) =>
        /^https?:\/\//.test(part) ? (
          <a
            key={index}
            href={part}
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-600 underline hover:text-blue-800 break-all"
          >
            {part}
          </a>
        ) : (
          part
        )
      )}
    </p>
  );
}
